/* -----------------------------------------------------------------------------------------------------
  - Created: [14-02-2025] by [SREERAJ]
  - Modified: [02-05-25] 
  - Description: This file contains Employee listing 
  -------------------------------------------------------------------------------------------------------
*/
import React, { useCallback, useEffect, useRef, useState } from 'react';
import './WorkforceFormStyle.css'
import { Grid } from '@mui/joy';
import dayjs from 'dayjs';
import { useNavigate, useParams } from 'react-router-dom';
import CustomTextFieldWithIcon from '../../../../Components/custom_components/custom_text_field/CustomTextFieldWithIcon';
import ActionButton from '../../../../Components/custom_components/CustomButtons/ActionButton/ActionButton';
import 'react-phone-number-input/style.css';
import CustomDatePicker from '../../../../Components/custom_components/CustomDatePicker/CustomDatePicker';
import CustomSelectDropdown from '../../../../Components/custom_components/CustomSelectDropdown/CustomSelectDropdown';
import { get_roles_with_pagination } from '../../../../config/SettingsApis/rolesApis';
import { get_designation_with_pagination } from '../../../../config/SettingsApis/designationApis';
import { get_workforce_by_id, workforce_creation, workforce_update } from '../../../../config/Resource/workforceApis';
import { ErrorToast, InfoToast, SuccessToast } from '../../../../utils/toast';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import { get_categories_with_pagination } from '../../../../config/SettingsApis/categorieApis';
import { get_technology_with_out_pagination, get_technology_with_pagination } from '../../../../config/Resource/technologyApis';
import { statusOptions } from '../../../../utils/constants';
import CustomStepper from '../../../../Components/CustomStepper/CustomStepper';
import { get_classifications_with_pagination } from '../../../../config/SettingsApis/classificationApis';


const WorkforceForm2 = () => {
    const { userRole, userID } = useParams();
    const navigate = useNavigate()

    const [userId, setUserId] = useState(null); //for get user id after a save

    const [formData, setFormData] = useState({
        UD_name: "",
        UD_StaffNo: '',
        Nationality: "",
        UD_phone: "",
        personal_phone: "",
        UD_email: "",
        LD_RoleId: '',
        UD_DesignationId: '',
        UD_address: "",
        UD_OptimaNo: "",
        UD_JoiningDate: null,
        dob: null,
        UD_ProfilePic: "",

        PassportNo: "",
        PassportIssueDate: null,
        UD_JoiningDate: null,
        EmiratesIDNo: "",
        HSE_Passport: "",
        EmiratesIDExpiry: null,
        PersonnelIDNo: "",
        LaborCardExpiry: null,
        ResidenceVisaFileNo: "",
        ResidenceVisaIssueDate: null,
        ResidenceVisaExpiryDate: null,
        LD_username: "",
        LD_password: "",

        Cicpa_Onshore: "",
        Cicpa_Onshore_expiry: null,
        Cicpa_Offshore: "",
        Cicpa_Offshore_expiry: null,
        Boseit_Expiry: null,
        Basic_H2s_Expiry: null,
        Adnoc_Medical_Exp: null,
        Adnoc_HSE_Induction: null,

        technologies: [],
        UD_status: 1,
        technology: '',
        category: '',
    });
    const [errors, setErrors] = useState({});

    const [technologyList, SetTechnologyList] = useState([]);
    const [allTechnologyList, SetAlTechnologyList] = useState([]);
    const [categoryLevelList, setCategoryLevelList] = useState([]);
    const [rolesList, setRolesList] = useState([]);
    const [designationList, setDesignationList] = useState([]);
    const [classificationList, setClassificationList] = useState([]);


    const [activeStep, setActiveStep] = useState(0); // Used to control the form activeStep
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);

    const handleReset = () => {
        setActiveStep(0)
        setFormData({
            UD_name: "",
            UD_StaffNo: '',
            Nationality: "",
            UD_phone: "",
            personal_phone: "",
            UD_email: "",
            LD_RoleId: '',
            UD_DesignationId: '',
            UD_address: "",
            UD_OptimaNo: "",
            UD_JoiningDate: null,
            dob: null,
            UD_ProfilePic: "",

            PassportNo: "",
            PassportIssueDate: null,
            UD_JoiningDate: null,
            EmiratesIDNo: "",
            HSE_Passport: "",
            EmiratesIDExpiry: null,
            PersonnelIDNo: "",
            LaborCardExpiry: null,
            ResidenceVisaFileNo: "",
            ResidenceVisaIssueDate: null,
            ResidenceVisaExpiryDate: null,
            LD_username: "",
            LD_password: "",

            Cicpa_Onshore: "",
            Cicpa_Onshore_expiry: null,
            Cicpa_Offshore: "",
            Cicpa_Offshore_expiry: null,
            Boseit_Expiry: null,
            Basic_H2s_Expiry: null,
            Adnoc_Medical_Exp: null,
            Adnoc_HSE_Induction: null,

            technologies: [],
            UD_status: 1,
            technology: '',
            category: '',
        });

        setErrors({});
        setActiveStep(0); // Optional: reset stepper if needed
    };
    // FETCH Roles
    const fetchRoles = async () => {
        try {
            const params = {
                status: 1 //1MEANS ACTIVE 
            }
            const response = await get_roles_with_pagination(params);
            if (response?.status === "success") {
                // Transform data into the desired format with label and value
                const transformedData = response.data.data?.map((item) => ({
                    label: item?.Rolename,
                    value: item?.RoleID
                }));

                // Set the transformed data to the state
                setRolesList(transformedData || []);
            } else {
                setRolesList([]);
            }
        } catch (error) {
            console.error('Error fetching :', error);
            setRolesList([]);
        }
    };

    // FETCH Classifications
    const fetchClassifications = async () => {
        try {
            const params = {
                status: 1 //1MEANS ACTIVE 
            }
            const response = await get_classifications_with_pagination(params);
            if (response?.status === "success") {
                // Transform data into the desired format with label and value
                const transformedData = response?.data?.map((item) => ({
                    label: item?.ClassificationName,
                    value: item?.id
                }));

                // Set the transformed data to the state
                setClassificationList(transformedData || []);
            } else {
                setClassificationList([]);
            }
        } catch (error) {
            console.error('Error fetching :', error);
            setClassificationList([]);
        }
    };

    // FETCH Designation 
    const fetchDesignation = async () => {
        try {
            const params = {
                status: 1 //1MEANS ACTIVE 
            }
            const response = await get_designation_with_pagination(params);
            if (response?.status === "success") {
                // Transform data into the desired format with label and value
                const transformedData = response.data.data?.map((item) => ({
                    label: item?.Designation_Name,
                    value: item?.DesignationId
                }));

                // Set the transformed data to the state
                setDesignationList(transformedData || []);
            } else {
                setDesignationList([]);
            }
        } catch (error) {
            console.error('Error fetching :', error);
            setDesignationList([]);
        }
    };

    // // FETCH CategoryLevels 
    const fetchCategoryLevels = async () => {
        try {
            const params = {
                status: 1 //1MEANS ACTIVE 
            }
            const response = await get_categories_with_pagination(params);
            if (response?.status === "success") {
                // Transform data into the desired format with label and value
                const transformedData = response.data.data?.map((item) => ({
                    label: item?.Name,
                    value: item?.CLL_Id
                }));

                // Set the transformed data to the state
                setCategoryLevelList(transformedData || []);
            } else {
                setCategoryLevelList([]);
            }
        } catch (error) {
            console.error('Error fetching :', error);
            setCategoryLevelList([]);
        }
    };

    // // FETCH All Technology 
    const fetchAllTechnology = async () => {
        try {
            const response = await get_technology_with_out_pagination();
            if (response?.status === "success") {

                // Transform data into the desired format with label and value
                const transformedData = response.data.data?.map((item) => ({
                    label: item?.TechnologiesName,
                    value: item?.TechnologiesTypeId
                }));
                // Set the transformed data to the state
                SetAlTechnologyList(transformedData || []);
            } else {
                SetAlTechnologyList([]);
            }
        } catch (error) {
            console.error('Error fetching :', error);
            SetAlTechnologyList([]);
        }
    };

    // // FETCH Technology 
    const fetchTechnology = async () => {
        try {
            const params = {
                status: 1 //1MEANS ACTIVE 
            }
            const response = await get_technology_with_pagination(params);
            if (response?.status === "success") {

                // Transform data into the desired format with label and value
                const transformedData = response.data.data?.map((item) => ({
                    label: item?.TechnologiesName,
                    value: item?.TechnologiesTypeId
                }));
                // Set the transformed data to the state
                SetTechnologyList(transformedData || []);
            } else {
                SetTechnologyList([]);
            }
        } catch (error) {
            console.error('Error fetching :', error);
            SetTechnologyList([]);
        }
    };

    useEffect(() => {
        if (userID) {
            setUserId(userID);
        }
    }, [userID]);

    // Handle get user information by id
    const fetchWorkforceInfoById = async (UserID) => {
        try {
            const response = await get_workforce_by_id({ UserID });
            console.log("response", response);
            if (response?.status === "success") {
                const {
                    UD_name,
                    UD_DesignationId,
                    UD_EmiratesIDExpiry,
                    UD_EmiratesIDNo,
                    UD_HSE_Passport,
                    UD_ID,
                    UD_JoiningDate,
                    UD_LaborCardExpiry,
                    UD_Nationality,
                    UD_OfficialMobile,
                    UD_OptimaNo,
                    UD_PassportExpiryDate,
                    UD_PassportIssueDate,
                    UD_PassportNo,
                    UD_PersonnelIDNo,
                    UD_ProfilePicPath,
                    UD_ResidenceVisaExpiryDate,
                    UD_ResidenceVisaFileNo,
                    UD_ResidenceVisaIssueDate,
                    UD_address,
                    UD_email,
                    UD_phone,
                    UD_DOB,
                    username,
                    RoleId,
                    UD_workforceClassificationID,
                    UD_status,
                    UD_StaffNo,

                    UD_Cicpa_Onshore,
                    UD_Cicpa_Onshore_expiry,
                    UD_Cicpa_Offshore,
                    UD_Cicpa_Offshore_expiry,
                    UD_Boseit_Expiry,
                    UD_Basic_H2s_Expiry,
                    UD_Adnoc_Medical_Exp,
                    UD_Adnoc_HSE_Induction,

                    technologies
                } = response?.data || {};

                const transformedData = technologies?.map((item) => ({ //FOR DESTRCTURED FOR SHOWING 
                    technology_id: item?.TechnologiesTypeId,
                    category_level_id: item?.category_level
                }));

                // Set the initialValues with the fetched data
                const initialValues = {
                    UD_name: UD_name || '',
                    UD_email: UD_email || '',
                    UD_phone: UD_phone || '',
                    OfficialMobile: UD_OfficialMobile || '',
                    UD_address: UD_address || '',
                    UD_JoiningDate: UD_JoiningDate || '',
                    UD_status: UD_status || 1,
                    UD_DesignationId: UD_DesignationId || '',
                    UD_OptimaNo: UD_OptimaNo || '',
                    UD_StaffNo: UD_StaffNo || '',
                    Nationality: UD_Nationality || '',

                    LD_RoleId: RoleId || '',
                    UD_workforceClassificationID: UD_workforceClassificationID || '',

                    // skills: '',
                    dob: UD_DOB || '',
                    UD_ProfilePic: UD_ProfilePicPath || '',

                    PassportNo: UD_PassportNo || '',
                    PassportIssueDate: UD_PassportIssueDate || null,
                    PassportExpiryDate: UD_PassportExpiryDate || null,
                    EmiratesIDNo: UD_EmiratesIDNo || '',
                    HSE_Passport: UD_HSE_Passport || '',
                    EmiratesIDExpiry: UD_EmiratesIDExpiry || '',
                    PersonnelIDNo: UD_PersonnelIDNo || '',
                    LaborCardExpiry: UD_LaborCardExpiry || '',
                    ResidenceVisaFileNo: UD_ResidenceVisaFileNo || '',
                    ResidenceVisaIssueDate: UD_ResidenceVisaIssueDate || null,
                    ResidenceVisaExpiryDate: UD_ResidenceVisaExpiryDate || null,
                    LD_username: username || '',
                    LD_password: '',

                    Cicpa_Onshore: UD_Cicpa_Onshore || '',
                    Cicpa_Onshore_expiry: UD_Cicpa_Onshore_expiry || '',
                    Cicpa_Offshore: UD_Cicpa_Offshore || '',
                    Cicpa_Offshore_expiry: UD_Cicpa_Offshore_expiry || '',
                    Boseit_Expiry: UD_Boseit_Expiry || '',
                    Basic_H2s_Expiry: UD_Basic_H2s_Expiry || '',
                    Adnoc_Medical_Exp: UD_Adnoc_Medical_Exp || '',
                    Adnoc_HSE_Induction: UD_Adnoc_HSE_Induction || '',



                    technologies: transformedData
                };

                // Manually set the form values
                setFormData((prev) => ({
                    ...prev,
                    ...initialValues,
                    // technology: '',
                    // category: '',
                }));

            } else {
                ErrorToast(response?.message || 'Something went wrong!');
            }
        } catch (error) {
            ErrorToast('Something went wrong!');
        }
    };

    // FOR GET LIST
    useEffect(() => {
        fetchRoles()
        fetchClassifications()
        fetchTechnology()
        fetchDesignation();
        fetchAllTechnology()
        fetchCategoryLevels()
    }, []);


    // for handle input chnage 
    const handleInputChange = useCallback((e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
        if (errors[name]) {
            setErrors((prev) => ({ ...prev, [name]: "" }));
        }
    }, [errors]);

    const handleSelectChange = (name, selectedOption) => {
        setFormData((prev) => ({ ...prev, [name]: selectedOption?.value || "" }));

        // Corrected: use "name" to clear the right field's error
        setErrors((prev) => ({ ...prev, [name]: '' }));
    };

    const handleDateChange = (name, date) => {
        setFormData((prev) => ({ ...prev, [name]: date }));
        // Clear error for that specific date field
        setErrors((prev) => ({ ...prev, [name]: '' }))
    };

    // Manual validation
    const validateForm = () => {
        const newErrors = {};

        // Full name
        if (!formData.UD_name.trim()) newErrors.UD_name = 'Full Name is required';

        // Email validation
        const emailRegex = /^[a-zA-Z0-9]+([._+-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/;
        if (!formData.UD_email.trim()) {
            newErrors.UD_email = 'Email is required';
        } else if (!emailRegex.test(formData.UD_email)) {
            newErrors.UD_email = 'Invalid email format';
        }

        // Passport Issue Date
        if (
            formData.PassportIssueDate &&
            !dayjs(formData.PassportIssueDate, 'DD-MM-YYYY', true).isValid()
        ) {
            newErrors.PassportIssueDate = 'Passport Issue Date is invalid';
        }

        // Passport Expiry Date
        if (
            formData.PassportExpiryDate &&
            !dayjs(formData.PassportExpiryDate, 'DD-MM-YYYY', true).isValid()
        ) {
            newErrors.PassportExpiryDate = 'Passport Expiry Date is invalid';
        }

        // Passport Expiry Date > Passport Issue Date
        if (formData.PassportIssueDate && formData.PassportExpiryDate) {
            const start = dayjs(formData.PassportIssueDate, 'DD-MM-YYYY', true);
            const end = dayjs(formData.PassportExpiryDate, 'DD-MM-YYYY', true);
            if (!end.isAfter(start)) {
                newErrors.PassportExpiryDate = 'Passport Expiry Date must be after Issue Date';
            }
        }

        // Residence Visa Issue Date
        if (
            formData.ResidenceVisaIssueDate &&
            !dayjs(formData.ResidenceVisaIssueDate, 'DD-MM-YYYY', true).isValid()
        ) {
            newErrors.ResidenceVisaIssueDate = 'Residence Visa Issue Date is invalid';
        }

        // Residence Visa Expiry Date
        if (
            formData.ResidenceVisaExpiryDate &&
            !dayjs(formData.ResidenceVisaExpiryDate, 'DD-MM-YYYY', true).isValid()
        ) {
            newErrors.ResidenceVisaExpiryDate = 'Residence Visa Expiry Date is invalid';
        }

        // Residence Visa Expiry Date > Issue Date
        if (formData.ResidenceVisaIssueDate && formData.ResidenceVisaExpiryDate) {
            const start = dayjs(formData.ResidenceVisaIssueDate, 'DD-MM-YYYY', true);
            const end = dayjs(formData.ResidenceVisaExpiryDate, 'DD-MM-YYYY', true);
            if (!end.isAfter(start)) {
                newErrors.ResidenceVisaExpiryDate = 'Residence Visa Expiry must be after Issue Date';
            }
        }

        // Official Mobile
        if (formData.OfficialMobile && (!/^[0-9]+$/.test(formData.OfficialMobile) || formData.OfficialMobile.length > 20)) {
            newErrors.OfficialMobile = 'Official Phone must be numeric and ≤ 20 digits';
        }

        // Personal Phone
        if (!formData.UD_phone.trim()) {
            newErrors.UD_phone = 'Personal Phone Number is required';
        } else if (!/^[0-9]+$/.test(formData.UD_phone) || formData.UD_phone.length > 20) {
            newErrors.UD_phone = 'Personal Phone must be numeric and ≤ 20 digits';
        }

        // Passport Number
        if (formData.PassportNo && formData.PassportNo.length > 20) {
            newErrors.PassportNo = 'Passport No. must not exceed 20 characters';
        }

        // Username
        if (!formData.LD_username.trim()) {
            newErrors.LD_username = 'Username is required';
        } else if (formData.LD_username.length > 30) {
            newErrors.LD_username = 'Username must not exceed 30 characters';
        }

        // Password
        if (!userId) {
            const password = formData.LD_password;
            if (!password) {
                newErrors.LD_password = 'Password is required';
            } else {
                if (password.length < 8 || password.length > 20) {
                    newErrors.LD_password = 'Password must be 8–20 characters';
                } else if (!/[a-z]/.test(password)) {
                    newErrors.LD_password = 'Must contain at least one lowercase letter';
                } else if (!/[A-Z]/.test(password)) {
                    newErrors.LD_password = 'Must contain at least one uppercase letter';
                } else if (!/[0-9]/.test(password)) {
                    newErrors.LD_password = 'Must contain at least one digit';
                } else if (!/[@$!%*#?&]/.test(password)) {
                    newErrors.LD_password = 'Must contain at least one special character';
                }
            }
        } else if (formData.LD_password.length > 20) {
            newErrors.LD_password = 'Password must not exceed 20 characters';
        }

        // Role
        if (!formData.LD_RoleId) {
            newErrors.LD_RoleId = 'Role is required';
        }

        // Classification
        if (!formData.UD_workforceClassificationID) {
            newErrors.UD_workforceClassificationID = 'Classification is required';
        }

        // Set and return errors
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Handle saving equipment data (add/edit)
    const handleWorkforceSave = async (values) => {
        try {
            setIsButtonDisabled(true);
            const apiFunction = Boolean(userId) ? workforce_update : workforce_creation;
            if (Boolean(userId)) values.userID = userId;

            const response = await apiFunction(values);
            const message = response?.data?.message || 'Something went wrong!';
            if (response?.data?.status === "success") {
                SuccessToast(message);
                setUserId(response?.data?.user_id || userId)

                if (activeStep === 0) {
                    setActiveStep(activeStep + 1)
                } else if (activeStep === 1) {
                    setActiveStep(activeStep + 1)
                } else {
                    navigate(`/resources/workforce/list`);
                }

            } else {
                ErrorToast(message);
            }
        } catch (error) {
            const errorMessage = error?.data?.errors ? Object.values(error.data.errors)[0][0] : 'Something went wrong!';
            ErrorToast(errorMessage);
        } finally {
            setIsButtonDisabled(false);
        }
    };

    const handleSubmit = () => {
        if (validateForm()) {
            handleWorkforceSave(formData);
            console.log("Form Submitted:", formData);
        } else {
            console.log("Validation failed");
        }
    };

    // NEXT TAB CLICK WITHOUT UPDATE FORM VIA API
    const handleNextStep = (stepIndex) => {
        setActiveStep(stepIndex)
    }
    const steps = ['Personal Details', 'Documents', 'Certification '];

    // Handle "Prev" button click
    const handlePrev = () => {
        setActiveStep(activeStep - 1)
    };

    const handleClose = () => {
        navigate(`/resources/workforce/list`);
    };
    // Add the selected technology and category level to the formik values
    const handleAddTechnology = () => {
        let hasError = false;
        const newErrors = {};

        // Validation: technology
        if (!formData.technology) {
            newErrors.technology = "Technology is required";
            hasError = true;
        }

        // Validation: category
        if (!formData.category) {
            newErrors.category = "Category level is required";
            hasError = true;
        }

        if (hasError) {
            setErrors((prev) => ({ ...prev, ...newErrors }));
            return;
        }

        const newTechnology = {
            technology_id: formData.technology,
            category_level_id: formData.category
        };

        const isExist = (formData.technologies || []).some(
            (tech) =>
                tech.technology_id === newTechnology.technology_id &&
                tech.category_level_id === newTechnology.category_level_id
        );

        if (isExist) {
            InfoToast("This Technology Category level combination has already been added!");
            return;
        }

        // Add to the list
        const updatedList = [...formData.technologies, newTechnology];
        setFormData((prev) => ({
            ...prev,
            technologies: updatedList,
            technology: "",
            category: ""
        }));

        // Clear field errors
        setErrors((prev) => ({
            ...prev,
            technology: "",
            category: ""
        }));
    };

    // Handle deleting a technology from the array
    const handleDeleteTechnology = (index) => {
        const updated = [...formData.technologies];
        updated.splice(index, 1);
        setFormData((prev) => ({
            ...prev,
            technologies: updated
        }));
    };
    // // Create Maps for technology and category labels
    const categoryLabel = categoryLevelList?.length > 0
        ? new Map(categoryLevelList?.map(item => [item.value, item.label]))
        : new Map();

    const technologyLabel = allTechnologyList?.length > 0
        ? new Map(allTechnologyList.map(item => [item?.value, item?.label]))
        : new Map();

    const shouldShowDiv = true

    // FETCH THE USER DETAILS EVERY STEP AFTER UPDATE
    useEffect(() => {
        if (userId) {
            fetchWorkforceInfoById(userId);
        }
    }, [userId, activeStep]);
    return (

        <div>
            <Grid container columnSpacing={1}>

                <Grid xs={12} md={12}>
                    <div className="section-border">
                        <CustomStepper activeStep={activeStep} steps={steps} handleNextStep={handleNextStep} userId={userId} />
                    </div>
                </Grid>
                {/* Personal Info Section */}

                {activeStep === 0 && (
                    <div className="section-border">
                        <Grid container spacing={2}>
                            <Grid xs={12} md={4}>
                                <div className="label-container">
                                    <span className="label">
                                        Full Name<span className="label_required_remark">*</span>
                                    </span>
                                </div>

                                <div className="custom-textfield-container">
                                    <CustomTextFieldWithIcon
                                        id="UD_name"
                                        name="UD_name"
                                        placeholder="Enter Full Name"
                                        value={formData.UD_name}
                                        onChange={handleInputChange}
                                        error={Boolean(errors.UD_name)}
                                        helperText={errors.UD_name}
                                        maxLength={255}
                                    />
                                </div>
                            </Grid>
                            <Grid xs={12} md={4}>
                                <div className="label-container">
                                    <span className="label">Nationality
                                    </span>
                                </div>
                                <div className="custom-textfield-container">
                                    <CustomTextFieldWithIcon
                                        id="Nationality"
                                        name="Nationality"
                                        placeholder="Enter Nationality"
                                        value={formData.Nationality}
                                        onChange={handleInputChange}
                                        error={Boolean(errors.Nationality)}
                                        helperText={errors.Nationality}
                                    />
                                </div>
                            </Grid>

                            <Grid xs={12} md={4}>
                                <div className="label-container">
                                    <span className="label">Staff No
                                        {/* <span className="label_required_remark">*</span> */}
                                    </span>
                                </div>
                                <div className="custom-textfield-container">
                                    <CustomTextFieldWithIcon
                                        id="UD_StaffNo"
                                        name="UD_StaffNo"
                                        placeholder="Enter Staff No"
                                        value={formData.UD_StaffNo}
                                        onChange={handleInputChange}
                                        error={Boolean(errors.UD_StaffNo)}
                                        helperText={errors.UD_StaffNo}
                                        maxLength={10}
                                    />

                                </div>
                            </Grid>


                            {shouldShowDiv && (
                                <Grid xs={12} md={4}>
                                    <div className="label-container">
                                        <span className="label">Role<span className="label_required_remark">*</span></span>
                                    </div>
                                    <div className="custom-textfield-container">
                                        <CustomSelectDropdown
                                            name="LD_RoleId"
                                            value={rolesList.find(opt => opt.value === formData.LD_RoleId) || null}
                                            onChange={(option) => handleSelectChange('LD_RoleId', option)}
                                            options={rolesList}
                                            placeholder="Select Designation"
                                            error={Boolean(errors.LD_RoleId)}
                                            helperText={errors.LD_RoleId}
                                            isClearable={false}
                                        />
                                    </div>
                                </Grid>
                            )}

                            {shouldShowDiv && (
                                <Grid xs={12} md={4}>
                                    <div className="label-container">
                                        <span className="label">Classification<span className="label_required_remark">*</span></span>
                                    </div>
                                    <div className="custom-textfield-container">
                                        <CustomSelectDropdown
                                            name="UD_workforceClassificationID"
                                            value={classificationList?.find(opt => opt.value === formData.UD_workforceClassificationID) || null}
                                            onChange={(option) => handleSelectChange('UD_workforceClassificationID', option)}
                                            options={classificationList}
                                            placeholder="Select Classification"
                                            error={Boolean(errors.UD_workforceClassificationID)}
                                            helperText={errors.UD_workforceClassificationID}
                                            isClearable={false}
                                        // isDisabled={ }

                                        />
                                    </div>
                                </Grid>
                            )}

                            <Grid xs={12} md={4}>
                                <div className="label-container">
                                    <span className="label">Designation
                                        {/* <span className="label_required_remark">*</span> */}
                                    </span>
                                </div>
                                <div className="custom-textfield-container">
                                    <CustomSelectDropdown
                                        name="UD_DesignationId"
                                        value={designationList?.find(opt => opt.value === formData.UD_DesignationId) || null}
                                        onChange={(option) => handleSelectChange('UD_DesignationId', option)}
                                        options={designationList}
                                        placeholder="Select Designation"
                                        error={Boolean(errors.UD_DesignationId)}
                                        helperText={errors.UD_DesignationId}
                                    />

                                </div>
                            </Grid>


                            <Grid xs={12} md={4}>
                                <div className="label-container">
                                    <span className="label">Official Phone Number
                                        {/* <span className="label_required_remark">*</span> */}
                                    </span>
                                </div>
                                <div className="custom-textfield-container">
                                    <CustomTextFieldWithIcon
                                        id="OfficialMobile"
                                        name="OfficialMobile"
                                        placeholder="Enter Official Phone Number"
                                        value={formData.OfficialMobile}
                                        onChange={handleInputChange}
                                        error={Boolean(errors.OfficialMobile)}
                                        helperText={errors.OfficialMobile}
                                        maxLength={20} //added max length for number
                                    />
                                </div>
                            </Grid>

                            <Grid xs={12} md={4}>
                                <div className="label-container">
                                    <span className="label">Personal Phone Number
                                        <span className="label_required_remark">*</span>
                                    </span>
                                </div>
                                <div className="custom-textfield-container">
                                    <CustomTextFieldWithIcon
                                        id="UD_phone"
                                        name="UD_phone"
                                        placeholder="Enter Personal Phone Number"
                                        value={formData.UD_phone}
                                        onChange={handleInputChange}
                                        error={Boolean(errors.UD_phone)}
                                        helperText={errors.UD_phone}
                                        maxLength={20} //added max length for number
                                    />
                                </div>
                            </Grid>

                            <Grid xs={12} md={4}>
                                <div className="label-container">
                                    <span className="label">Email<span className="label_required_remark">*</span></span>
                                </div>
                                <div className="custom-textfield-container">
                                    <CustomTextFieldWithIcon
                                        id="UD_email"
                                        name="UD_email"
                                        type="email"
                                        placeholder="Enter Email"
                                        value={formData.UD_email}
                                        onChange={handleInputChange}
                                        error={Boolean(errors.UD_email)}
                                        helperText={errors.UD_email}
                                        maxLength={255} //added max length for number

                                    />
                                </div>
                            </Grid>

                            <Grid xs={12} md={4}>
                                <div className="label-container">
                                    <span className="label">Address
                                        {/* <span className="label_required_remark">*</span> */}
                                    </span>
                                </div>
                                <div className="custom-textfield-container">
                                    <CustomTextFieldWithIcon
                                        id="UD_address"
                                        name="UD_address"
                                        placeholder="Enter Address"
                                        value={formData.UD_address}
                                        onChange={handleInputChange}
                                        error={Boolean(errors.UD_address)}
                                        helperText={errors.UD_address}
                                        maxLength={505}
                                    />
                                </div>
                            </Grid>

                            <Grid xs={12} md={4}>
                                <div className="label-container">
                                    <span className="label">Joining Date
                                        {/* <span className="label_required_remark">*</span> */}
                                    </span>
                                </div>
                                <div className="custom-textfield-container">
                                    <CustomDatePicker
                                        name="UD_JoiningDate"
                                        value={dayjs(formData.UD_JoiningDate, "DD-MM-YYYY")}
                                        onChange={(date) => handleDateChange('UD_JoiningDate', date)}
                                        error={Boolean(errors.UD_JoiningDate)}
                                        helperText={errors.UD_JoiningDate}
                                        isDisabled={false}

                                    />
                                </div>
                            </Grid>

                            <Grid xs={12} md={4}>
                                <div className="label-container">
                                    <span className="label">DOB
                                        {/* <span className="label_required_remark">*</span> */}
                                    </span>
                                </div>
                                <div className="custom-textfield-container">
                                    <CustomDatePicker
                                        name="dob"
                                        value={dayjs(formData.dob, "DD-MM-YYYY")}
                                        onChange={(date) => handleDateChange('dob', date)}
                                        error={Boolean(errors.dob)}
                                        helperText={errors.dob}
                                        isDisabled={false}

                                    />
                                </div>
                            </Grid>
                            {shouldShowDiv && <Grid xs={12} md={4}>
                                <div className="label-container">
                                    <span className="label">Status<span className="label_required_remark">*</span></span>
                                </div>
                                <div className="custom-textfield-container">
                                    <CustomSelectDropdown
                                        name="UD_status"
                                        value={statusOptions.find(opt => opt.value === formData.UD_status) || null}
                                        onChange={(option) => handleSelectChange('UD_status', option)}
                                        options={statusOptions}
                                        placeholder="Select Status"
                                        error={Boolean(errors.UD_status)}
                                        helperText={errors.UD_status}
                                        isClearable={false}
                                    />
                                </div>
                            </Grid>}

                        </Grid>

                        <div className="section-border">
                            <Grid xs={12} md={12} className="mt-3 mb-3">
                                <div className="label-container">
                                    <span className="employee-form-title">Login Details</span>
                                </div>
                            </Grid>

                            <Grid container spacing={2}>

                                <Grid item xs={12} md={4}>
                                    <div className="label-container">
                                        <span className="label">Username<span className='label_required_remark'>*</span></span>
                                    </div>
                                    <div className="custom-textfield-container">
                                        <CustomTextFieldWithIcon

                                            id="LD_username"
                                            name="LD_username"
                                            placeholder="Enter Username"
                                            value={formData.LD_username}
                                            onChange={handleInputChange}
                                            error={Boolean(errors.LD_username)}
                                            helperText={errors.LD_username}
                                            isDisabled={Boolean(userId)}
                                            maxLength={255}

                                        />
                                    </div>
                                </Grid>

                                {!Boolean(userId) && <Grid item xs={12} md={4}>
                                    <div className="label-container">
                                        <span className="label">Password<span className='label_required_remark'>*</span></span>
                                    </div>
                                    <div className="custom-textfield-container">
                                        <CustomTextFieldWithIcon
                                            id="LD_password"
                                            name="LD_password"
                                            placeholder="Enter Password"
                                            value={formData.LD_password}
                                            onChange={handleInputChange}
                                            error={Boolean(errors.LD_password)}
                                            helperText={errors.LD_password}

                                        />
                                    </div>
                                </Grid>}

                            </Grid>
                        </div>
                    </div>

                )}

                {/* Documents  Section */}
                {activeStep === 1 && <div className="section-border">

                    <Grid xs={12} md={12} className="mt-3 mb-3">
                        <div className="label-container">
                            <span className="employee-form-title">Documents Details</span>
                        </div>
                    </Grid>

                    <Grid container spacing={2}>

                        {/* PASSPORT SECTION START */}
                        <Grid item xs={12} md={4}>
                            <div className="label-container">
                                <span className="label">Passport No
                                    {/* <span className='label_required_remark'>*</span> */}
                                </span>
                            </div>
                            <div className="custom-textfield-container">
                                <CustomTextFieldWithIcon
                                    id="PassportNo"
                                    name="PassportNo"
                                    placeholder="Enter Passport No"
                                    value={formData.PassportNo}
                                    onChange={handleInputChange}
                                    error={Boolean(errors.PassportNo)}
                                    helperText={errors.PassportNo}
                                    maxLength={255}
                                />
                            </div>
                        </Grid>
                        <Grid xs={12} md={4}>
                            <div className="label-container">
                                <span className="label">Passport Issue Date
                                    {/* <span className='label_required_remark'>*</span> */}
                                </span>
                            </div>
                            <div className="custom-textfield-container">
                                <CustomDatePicker
                                    name="PassportIssueDate"
                                    value={dayjs(formData.PassportIssueDate, "DD-MM-YYYY")}
                                    onChange={(date) => handleDateChange('PassportIssueDate', date)}
                                    error={Boolean(errors.PassportIssueDate)}
                                    helperText={errors.PassportIssueDate}
                                    isDisabled={false}

                                />
                            </div>
                        </Grid>
                        <Grid xs={12} md={4}>
                            <div className="label-container">
                                <span className="label">Passport Expiry Date
                                    {/* <span className='label_required_remark'>*</span> */}
                                </span>
                            </div>
                            <div className="custom-textfield-container">
                                <CustomDatePicker
                                    name="PassportExpiryDate"
                                    value={dayjs(formData.PassportExpiryDate, "DD-MM-YYYY")}
                                    onChange={(date) => handleDateChange('PassportExpiryDate', date)}
                                    error={Boolean(errors.PassportExpiryDate)}
                                    helperText={errors.PassportExpiryDate}
                                    isDisabled={false}

                                />
                            </div>
                        </Grid>
                        {/* HSE PASSPORT SECTION END */}
                        <Grid item xs={12} md={4}>
                            <div className="label-container">
                                <span className="label">HSE Passport  No
                                    {/* <span className='label_required_remark'>*</span> */}
                                </span>
                            </div>
                            <div className="custom-textfield-container">
                                <CustomTextFieldWithIcon
                                    id="HSE_Passport"
                                    name="HSE_Passport"
                                    placeholder="Enter HSE Passport No"
                                    value={formData.HSE_Passport}
                                    onChange={handleInputChange}
                                    error={Boolean(errors.HSE_Passport)}
                                    helperText={errors.HSE_Passport}
                                    maxLength={255}
                                />
                            </div>
                        </Grid>

                        {/* PASSPORT SECTION END */}
                        <Grid item xs={12} md={4}>
                            <div className="label-container">
                                <span className="label">Emirates ID No
                                    {/* <span className='label_required_remark'>*</span> */}
                                </span>
                            </div>
                            <div className="custom-textfield-container">
                                <CustomTextFieldWithIcon
                                    id="EmiratesIDNo"
                                    name="EmiratesIDNo"
                                    placeholder="Enter Emirates ID No"
                                    value={formData.EmiratesIDNo}
                                    onChange={handleInputChange}
                                    error={Boolean(errors.EmiratesIDNo)}
                                    helperText={errors.EmiratesIDNo}
                                    maxLength={255}
                                />
                            </div>
                        </Grid>

                        <Grid xs={12} md={4}>
                            <div className="label-container">
                                <span className="label">Emirates ID Expiry Date
                                    {/* <span className='label_required_remark'>*</span> */}
                                </span>
                            </div>
                            <div className="custom-textfield-container">
                                <CustomDatePicker
                                    name="EmiratesIDExpiry"
                                    value={dayjs(formData.EmiratesIDExpiry, "DD-MM-YYYY")}
                                    onChange={(date) => handleDateChange('EmiratesIDExpiry', date)}
                                    error={Boolean(errors.EmiratesIDExpiry)}
                                    helperText={errors.EmiratesIDExpiry}
                                    isDisabled={false}
                                />
                            </div>
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <div className="label-container">
                                <span className="label">Personnel ID No
                                    {/* <span className='label_required_remark'>*</span> */}
                                </span>
                            </div>
                            <div className="custom-textfield-container">

                                <CustomTextFieldWithIcon
                                    id="PersonnelIDNo"
                                    name="PersonnelIDNo"
                                    placeholder="Enter Personnel ID No"
                                    value={formData.PersonnelIDNo}
                                    onChange={handleInputChange}
                                    error={Boolean(errors.PersonnelIDNo)}
                                    helperText={errors.PersonnelIDNo}
                                    maxLength={255}
                                />
                            </div>
                        </Grid>

                        <Grid xs={12} md={4}>
                            <div className="label-container">
                                <span className="label">Labor Card Expiry
                                    {/* <span className='label_required_remark'>*</span> */}
                                </span>
                            </div>
                            <div className="custom-textfield-container">
                                <CustomDatePicker
                                    name="LaborCardExpiry"
                                    value={dayjs(formData.LaborCardExpiry, "DD-MM-YYYY")}
                                    onChange={(date) => handleDateChange('LaborCardExpiry', date)}
                                    error={Boolean(errors.LaborCardExpiry)}
                                    helperText={errors.LaborCardExpiry}
                                    isDisabled={false}

                                />
                            </div>
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <div className="label-container">
                                <span className="label">Residence Visa File No
                                    {/* <span className='label_required_remark'>*</span> */}
                                </span>
                            </div>
                            <div className="custom-textfield-container">
                                <CustomTextFieldWithIcon
                                    id="ResidenceVisaFileNo"
                                    name="ResidenceVisaFileNo"
                                    placeholder="Enter Residence Visa File No"
                                    value={formData.ResidenceVisaFileNo}
                                    onChange={handleInputChange}
                                    error={Boolean(errors.ResidenceVisaFileNo)}
                                    helperText={errors.ResidenceVisaFileNo}
                                    maxLength={255}
                                />
                            </div>
                        </Grid>

                        <Grid xs={12} md={4}>
                            <div className="label-container">
                                <span className="label">Residence Visa Issue Date
                                    {/* <span className='label_required_remark'>*</span> */}
                                </span>
                            </div>
                            <div className="custom-textfield-container">
                                <CustomDatePicker
                                    name="ResidenceVisaIssueDate"
                                    value={dayjs(formData.ResidenceVisaIssueDate, "DD-MM-YYYY")}
                                    onChange={(date) => handleDateChange('ResidenceVisaIssueDate', date)}
                                    error={Boolean(errors.ResidenceVisaIssueDate)}
                                    helperText={errors.ResidenceVisaIssueDate}
                                    isDisabled={false}

                                />
                            </div>
                        </Grid>

                        <Grid xs={12} md={4}>
                            <div className="label-container">
                                <span className="label">Residence Visa Expiry Date
                                    {/* <span className='label_required_remark'>*</span> */}
                                </span>
                            </div>
                            <div className="custom-textfield-container">
                                <CustomDatePicker
                                    name="ResidenceVisaExpiryDate"
                                    value={dayjs(formData.ResidenceVisaExpiryDate, "DD-MM-YYYY")}
                                    onChange={(date) => handleDateChange('ResidenceVisaExpiryDate', date)}
                                    error={Boolean(errors.ResidenceVisaExpiryDate)}
                                    helperText={errors.ResidenceVisaExpiryDate}
                                    isDisabled={false}

                                />
                            </div>
                        </Grid>
                    </Grid>
                </div>}


                {/*  Certification  section start*/}
                {activeStep === 2 &&
                    <>
                        <div className="section-border">
                            <Grid xs={12} md={12} className="mt-3 mb-3">
                                <div className="label-container">
                                    <span className="employee-form-title">Certification Details

                                    </span>
                                </div>
                            </Grid>

                            <Grid container spacing={2}>

                                <Grid xs={12} md={4}>
                                    <div className="label-container">
                                        <span className="label">OPTIMA No
                                            {/* <span className="label_required_remark">*</span> */}
                                        </span>
                                    </div>
                                    <div className="custom-textfield-container">
                                        <CustomTextFieldWithIcon
                                            id="UD_OptimaNo"
                                            name="UD_OptimaNo"
                                            placeholder="Enter OPTIMA No"
                                            value={formData.UD_OptimaNo}
                                            onChange={handleInputChange}
                                            error={Boolean(errors.UD_OptimaNo)}
                                            helperText={errors.UD_OptimaNo}
                                            maxLength={255}
                                        />
                                    </div>
                                </Grid>

                                {/* CICPA On Shore No */}
                                <Grid item xs={12} md={4}>
                                    <div className="label-container">
                                        <span className="label">CICPA On Shore No
                                            {/* <span className="label_required_remark">*</span> */}
                                        </span>
                                    </div>
                                    <div className="custom-textfield-container">
                                        <CustomTextFieldWithIcon
                                            id="Cicpa_Onshore"
                                            name="Cicpa_Onshore"
                                            placeholder="Enter CICPA On Shore No"
                                            value={formData.Cicpa_Onshore}
                                            onChange={handleInputChange}
                                            error={Boolean(errors.Cicpa_Onshore)}
                                            helperText={errors.Cicpa_Onshore}
                                            maxLength={255}
                                        />
                                    </div>
                                </Grid>

                                {/* CICPA Onshore Expiry Date */}
                                <Grid item xs={12} md={4}>
                                    <div className="label-container">
                                        <span className="label">CICPA Onshore Expiry Date
                                            {/* <span className="label_required_remark">*</span> */}
                                        </span>
                                    </div>
                                    <div className="custom-textfield-container">
                                        <CustomDatePicker
                                            name="Cicpa_Onshore_expiry"
                                            value={dayjs(formData.Cicpa_Onshore_expiry, "DD-MM-YYYY")}
                                            onChange={(date) => handleDateChange('Cicpa_Onshore_expiry', date)}
                                            error={Boolean(errors.Cicpa_Onshore_expiry)}
                                            helperText={errors.Cicpa_Onshore_expiry}
                                            isDisabled={false}



                                        />
                                    </div>
                                </Grid>

                                {/* CICPA Off Shore No */}
                                <Grid item xs={12} md={4}>
                                    <div className="label-container">
                                        <span className="label">CICPA Off Shore No
                                            {/* <span className="label_required_remark">*</span> */}
                                        </span>
                                    </div>
                                    <div className="custom-textfield-container">
                                        <CustomTextFieldWithIcon


                                            id="Cicpa_Offshore"
                                            name="Cicpa_Offshore"
                                            placeholder="Enter CICPA Off Shore No"
                                            value={formData.Cicpa_Offshore}
                                            onChange={handleInputChange}
                                            error={Boolean(errors.Cicpa_Offshore)}
                                            helperText={errors.Cicpa_Offshore}
                                            maxLength={255}
                                        />
                                    </div>
                                </Grid>

                                {/* CICPA Off Shore Expiry Date */}
                                <Grid item xs={12} md={4}>
                                    <div className="label-container">
                                        <span className="label">CICPA Off Shore Expiry Date
                                            {/* <span className="label_required_remark">*</span> */}
                                        </span>
                                    </div>
                                    <div className="custom-textfield-container">
                                        <CustomDatePicker
                                            name="Cicpa_Offshore_expiry"
                                            value={dayjs(formData.Cicpa_Offshore_expiry, "DD-MM-YYYY")}
                                            onChange={(date) => handleDateChange('Cicpa_Offshore_expiry', date)}
                                            error={Boolean(errors.Cicpa_Offshore_expiry)}
                                            helperText={errors.Cicpa_Offshore_expiry}
                                            isDisabled={false}

                                        />
                                    </div>
                                </Grid>

                                {/* Bosexit Expiry Date */}
                                <Grid item xs={12} md={4}>
                                    <div className="label-container">
                                        <span className="label">Bosexit Expiry Date
                                            {/* <span className="label_required_remark">*</span> */}
                                        </span>
                                    </div>
                                    <div className="custom-textfield-container">
                                        <CustomDatePicker
                                            name="Boseit_Expiry"
                                            value={dayjs(formData.Boseit_Expiry, "DD-MM-YYYY")}
                                            onChange={(date) => handleDateChange('Boseit_Expiry', date)}
                                            error={Boolean(errors.Boseit_Expiry)}
                                            helperText={errors.Boseit_Expiry}
                                            isDisabled={false}

                                        />
                                    </div>
                                </Grid>

                                {/* Basic H2S Expiry Date */}
                                <Grid item xs={12} md={4}>
                                    <div className="label-container">
                                        <span className="label">Basic H2S Expiry Date
                                            {/* <span className="label_required_remark">*</span> */}
                                        </span>
                                    </div>
                                    <div className="custom-textfield-container">
                                        <CustomDatePicker
                                            name="Basic_H2s_Expiry"
                                            value={dayjs(formData.Basic_H2s_Expiry, "DD-MM-YYYY")}
                                            onChange={(date) => handleDateChange('Basic_H2s_Expiry', date)}
                                            error={Boolean(errors.Basic_H2s_Expiry)}
                                            helperText={errors.Basic_H2s_Expiry}
                                            isDisabled={false}
                                        />
                                    </div>
                                </Grid>

                                {/* ADNOC Medical Expiry Date */}
                                <Grid item xs={12} md={4}>
                                    <div className="label-container">
                                        <span className="label">ADNOC Medical Expiry Date
                                            {/* <span className="label_required_remark">*</span> */}
                                        </span>
                                    </div>
                                    <div className="custom-textfield-container">
                                        <CustomDatePicker
                                            name="Adnoc_Medical_Exp"
                                            value={dayjs(formData.Adnoc_Medical_Exp, "DD-MM-YYYY")}
                                            onChange={(date) => handleDateChange('Adnoc_Medical_Exp', date)}
                                            error={Boolean(errors.Adnoc_Medical_Exp)}
                                            helperText={errors.Adnoc_Medical_Exp}
                                            isDisabled={false}

                                        />
                                    </div>
                                </Grid>

                                {/* ADNOC HSE Induction */}
                                <Grid item xs={12} md={4}>
                                    <div className="label-container">
                                        <span className="label">ADNOC HSE Induction Date
                                            {/* <span className="label_required_remark">*</span> */}
                                        </span>
                                    </div>
                                    <div className="custom-textfield-container">
                                        <CustomDatePicker
                                            name="Adnoc_HSE_Induction"
                                            value={dayjs(formData.Adnoc_HSE_Induction, "DD-MM-YYYY")}
                                            onChange={(date) => handleDateChange('Adnoc_HSE_Induction', date)}
                                            error={Boolean(errors.Adnoc_HSE_Induction)}
                                            helperText={errors.Adnoc_HSE_Induction}
                                            isDisabled={false}
                                        />
                                    </div>
                                </Grid>
                                <Grid xs={12} md={4}>  </Grid>
                            </Grid>
                        </div>

                        <div className="section-border" style={{ width: '100%' }}>
                            <Grid container spacing={2}>
                                {/* Left side: Dropdowns */}
                                <Grid item xs={12}>
                                    <div className="label-container">
                                        <span className="employee-form-title">Skills</span>
                                    </div>
                                </Grid>

                                <Grid item xs={12} sm={6} md={4}>
                                    {/* Technology Dropdown */}
                                    <div className="label-container">
                                        <span className="label">Technology</span>
                                    </div>
                                    <div className="custom-textfield-container">
                                     
                                        <CustomSelectDropdown
                                            name="technology"
                                            value={technologyList.find(opt => opt.value === formData.technology) || null}
                                            onChange={(option) => {
                                                setFormData((prev) => ({ ...prev, technology: option?.value || "" }));
                                                setErrors((prev) => ({ ...prev, technology: "" }));
                                            }}
                                            options={technologyList}
                                            placeholder="Select Technology"
                                            error={Boolean(errors.technology)}
                                            helperText={errors.technology}
                                            isClearable={true}
                                        />
                                    </div>
                                </Grid>

                                <Grid item xs={12} sm={6} md={4}>
                                    {/* Category Dropdown */}
                                    <div className="label-container">
                                        <span className="label">Category Level</span>
                                    </div>
                                    <div className="custom-textfield-container">
                                        <CustomSelectDropdown
                                            name="category"
                                            value={categoryLevelList.find(opt => opt.value === formData.category) || null}
                                            onChange={(option) => {
                                                setFormData((prev) => ({ ...prev, category: option?.value || "" }));
                                                setErrors((prev) => ({ ...prev, category: "" }));
                                            }}
                                            options={categoryLevelList}
                                            placeholder="Select Category Level"
                                            error={Boolean(errors.category)}
                                            helperText={errors.category}
                                            isClearable={true}
                                        />
                                    </div>
                                </Grid>
                                {/* Add Technology Button */}
                                <Grid display='flex' alignItems="center">
                                    <ActionButton onClick={handleAddTechnology} label="Add" btnType="primary" />
                                </Grid>
                                {/* <div className="tech-cat-add-btn-container">
                                    <ActionButton onClick={handleAddTechnology} label="Add" btnType="primary" />
                                </div> */}

                                {/* Right side: Added Technologies */}
                                {formData?.technologies?.length > 0 && <Grid item xs={12} sm={12} md={6}>
                                    <div>
                                        <span className="employee-form-title">Added Skills</span>
                                        <div className="added-technologies">
                                            <Stack direction="row" spacing={1} flexWrap="wrap">
                                                {formData?.technologies?.map((tech, index) => (
                                                    <Chip
                                                        key={index}
                                                        label={` ${technologyLabel?.get(tech.technology_id) || 'Unknown'} (${categoryLabel?.get(tech.category_level_id) || 'Unknown'})`}
                                                        onDelete={() => handleDeleteTechnology(index)}
                                                        variant="outlined"
                                                    />
                                                ))}
                                            </Stack>
                                        </div>
                                    </div>
                                </Grid>}
                            </Grid>
                        </div>
                    </>
                }

            </Grid>

            <div className='form-bottom-action-buttons-container'>
                <ActionButton onClick={handleClose} label="Close" btnType="outlined" />
                {activeStep !== 0 && <ActionButton onClick={handlePrev} label="Prev" btnType="primary" />}
                {/* //added bye sreeraj 28-4-25 */}
                {!Boolean(userId) && <ActionButton
                    onClick={handleReset}
                    label="Reset" btnType="outlined" />}
                <ActionButton
                    btnDisable={isButtonDisabled}
                    onClick={handleSubmit}
                    label={activeStep === 2 ? `Save` : `Save & Next`} btnType="primary" />
            </div>
        </div>
    );
};

export default WorkforceForm2;


// onst handleInputChange = (e) => {
//     const { name, value } = e.target;

//     setFormData((prev) => ({
//         ...prev,
//         [name]: value,
//     }));

//     if (errors[name]) {
//         setErrors((prev) => ({
//             ...prev,
//             [name]: "",
//         }));
//     }
// };


// const handleSelectChange = (name, selectedOption) => {
//     setFormData((prev) => ({
//         ...prev,
//         [name]: selectedOption?.value || "",
//     }));

//     if (errors[name]) {
//         setErrors((prev) => ({
//             ...prev,
//             [name]: "",
//         }));
//     }
// };